$(document).ready(function () {
  $(document).on('click', '.geo-modal .close-modal', function (event) {
    event.preventDefault();

    var modal = $(this).closest('.geo-modal').fadeOut(200);

    if (modal.attr('id') === 'confirm-locale-modal') {
      if ($(this).hasClass('dont-ask-again')) {
        window.localStorage.geo_dont_ask = true;
      } else {
        window.sessionStorage.geo_redirect_dismissed = true;
      }

      var store = stores[window.localStorage.country];
      if (!store) {
        store = INT;
      }

      if (currentStore != store) {
        setTimeout(function () {
          showGeoNotification(store);
        }, 2000);
      }
    }

    return false;
  });

  /**
   * Helper function to detect if you're
   * in a Skincare section of the site
   *
   * @returns boolean
   */
  window.isSkincare = function () {
    return $('body').hasClass('skincare') ? true : false;
  };
});

// Global Scope Vars
var currentStore = null;
var EU = {
  hosts: ['eu.balibodyco.com'],
  protocol: 'https:',
  ownership: 'Europe',
  multiOwnership: 'Europe',
  multiPlural: 'Europe',
  plural: 'Europe',
  storeCode: 'EU',
};
var UK = {
  hosts: ['uk.balibodyco.com'],
  protocol: 'https:',
  ownership: 'UK',
  multiOwnership: 'UK',
  multiPlural: 'UK/International',
  plural: 'the UK',
  storeCode: 'UK',
};
var INT = {
  hosts: ['int.balibodyco.com'],
  protocol: 'https:',
  ownership: 'International',
  multiOwnership: 'International',
  multiPlural: 'International',
  plural: 'ROW',
  storeCode: 'INT',
};
var AU = {
  hosts: ['au.balibodyco.com', 'raak-bali-body.myshopify.com', 'localhost:3000'],
  protocol: 'https:',
  ownership: 'Australia',
  multiOwnership: 'Australia / N.Z',
  multiPlural: 'Australia / N.Z',
  plural: 'Australia / N.Z',
  storeCode: 'AU',
};
var stores = {
  US: {
    hosts: ['us.balibodyco.com'],
    protocol: 'https:',
    ownership: 'USA',
    multiOwnership: 'the USA',
    multiPlural: 'USA',
    plural: 'the USA',
    prefix: 'the ',
    storeCode: 'US',
  },
  CA: {
    hosts: ['ca.balibodyco.com'],
    protocol: 'https:',
    ownership: 'Canada',
    multiOwnership: 'Canada',
    multiPlural: 'Canada',
    plural: 'Canada',
    storeCode: 'CA',
  },
  AU: AU,
  NZ: AU,
  IE: UK,
  GB: UK,
  AT: EU,
  BE: EU,
  BG: EU,
  HR: EU,
  CY: EU,
  CZ: EU,
  DK: EU,
  EE: EU,
  FI: EU,
  FR: EU,
  DE: EU,
  GR: EU,
  HU: EU,
  IT: EU,
  LV: EU,
  LT: EU,
  LU: EU,
  MT: EU,
  NL: EU,
  AN: EU,
  PL: EU,
  PT: EU,
  RO: EU,
  SK: EU,
  SI: EU,
  ES: EU,
  SE: EU,
  CH: EU,

  INT: INT,
  EU: EU,
  UK: UK,
  RU: EU,
  IL: UK,
};

$(function () {
  /**
   * Regionalisation
   *
   * Show region switching modal if the user's location does not match
   * the current site region.
   */

  /**
   * If the user agent is a known bot or we're in the theme customiser,
   * return without doing anything. We don't want to show the regionalisation
   * modal to these user agents.
   */
  const isRobot = function () {
    const robotList =
      '(360spider|a6-indexer|aboundex|acoonbot|addthis|adidxbot|admantx|adsbot-google|adsbot-google-mobile|advbot|ahrefsbot|aihitbot|aisearchbot|antibot|apis-google|applebot|arabot|archive.org_bot|backlinkcrawler|baiduspider|bibnum.bnf|biglotron|bingbot|binlar|blekkobot|blexbot|bnf.fr_bot|brainobot|bubing|buzzbot|careerbot|cc metadata scaper|ccbot|changedetection|chrome-lighthouse|citeseerxbot|coccoc|commons-httpclient|content crawler spider|convera|crawler4j|crystalsemanticsbot|curl|cxensebot|cyberpatrol|discobot|domain re-animator bot|domaincrawler|dotbot|drupact|duckduckbot|duplexweb-google|ec2linkfinder|edisterbot|elisabot|europarchive.org|exabot|ezooms|facebookexternalhit|facebot|fast enterprise crawler|fast-webcrawler|feedfetcher-google|findlink|findthatfile|findxbot|fluffy|fr-crawler|g00g1e.net|gigablast|gingercrawler|gnam gnam spider|google favicon|google-read-aloud|googlebot|googlebot-image|googlebot-mobile|googlebot-news|googlebot-video|googleweblight|grapeshotcrawler|grub.org|gslfbot|heritrix|httpunit|httrack|ia_archiver|ichiro|integromedb|intelium_bot|interfaxscanbot|ioi|ip-web-crawler.com|ips-agent|it2media-domain-crawler|java|jyxobot|lb-spider|libwww|linguee bot|linkdex|lipperhey|lipperhey seo service|livelapbot|lssbot|lssrocketcrawler|ltx71|mail.ru_bot|mediapartners-google|megaindex|memorybot|mj12bot|mlbot|msnbot|msrbot|nerdbynature.bot|nerdybot|netresearchserver|ngbot|niki-bot|nutch|openindexspider|orangebot|page2rss|panscient|phpcrawl|postrank|proximic|psbot|purebot|python-urllib|qwantify|retrevopageanalyzer|rogerbot|scribdbot|seekbot|semanticscholarbot|semrushbot|seokicks-robot|seznambot|simplecrawler|sistrix crawler|sitebot|siteexplorer.info|slurp|smtbot|sogou|spbot|speedy|summify|tagoobot|teoma|toplistbot|turnitinbot|tweetmemebot|twengabot|twitterbot|urlappendbot|usinenouvellecrawler|voilabot|voyager|wbsearchbot|web-archive-net.com.bot|webcompanycrawler|webcrawler|webmon|wesee:search|wget|wocbot|woriobot|wotbox|xovibot|y!j-asr|yacybot|yandexbot|yanga|yeti|yoozbot)';
    const regex = new RegExp(robotList, 'i');
    const userAgent = navigator.userAgent;
    return regex.test(userAgent) ? true : false;
  };
  if (isRobot() || window.Shopify.designMode) {
    return;
  }

  // Don't perform this code if the user has already dismissed the modal this session.
  var $confirmModal = $('#confirm-locale-modal');
  var $selectModal = $('#select-locale-modal');
  var $dynamic = $confirmModal.find('.dynamic');
  var source = $dynamic.html();

  var $notification = $('.geo-notification');
  var $notificationText = $notification.find('.dynamic');
  var $notificationTextSource = $notificationText.html();

  for (var key in stores) {
    if (stores.hasOwnProperty(key)) {
      if (~stores[key].hosts.indexOf(window.location.host)) {
        currentStore = stores[key];
        break;
      }
    }
  }

  if (!(window.sessionStorage.geo_redirect_dismissed || window.localStorage.geo_dont_ask)) {
    geoip2.country(function (response) {
      console.log(response);
      var store = stores[response.country.iso_code];

      if (!store) {
        // Force countries on the european continent to go to the EU store
        if (response.continent.code === 'EU') {
          store = EU;
        } else {
          store = INT;
        }
      }

      window.localStorage.country = response.country.iso_code;

      if (~store.hosts.indexOf(window.location.host)) {
        // console.info('Looks like we\'re on the correct site.');
      } else {
        // console.info('Looks like we\'re on the incorrect site.');
        showGEOModal(store);
        document.querySelector('#modalTriggeredManually').style.display = 'none';
        document.querySelector('#modalTriggeredAuto').style.display = 'block';
      }
    }, $.noop);
  }

  /**
   * Show Geolocation Selection Modal
   *
   * @param {*} store
   */
  function showGEOModal(store) {
    let current = null;

    for (var key in stores) {
      if (stores.hasOwnProperty(key)) {
        if (~stores[key].hosts.indexOf(window.location.host)) {
          current = stores[key];
          break;
        }
      }
    }
    

    let templateDataStructure = {
      current: current,
      ownership: store.ownership || '',
      prefix: store.prefix || '',
      multiPlural: store.multiPlural || '',
      plural: store.plural || '',
      domain: store.hosts[0], // The first host should always be the correct one.
      link_domain: store.protocol + '//' + store.hosts[0],
    };

    // Update redirect link to Skincare specific link
    if (window.isSkincare()) {
      templateDataStructure.link_domain = `${store.protocol}//${store.hosts[0]}/pages/skincare-homepage`;
    }
    console.log(templateDataStructure);
    console.log(current);
    var dynamicHTML = source;
    dynamicHTML = dynamicHTML.replaceAll('{{multiPlural}}', templateDataStructure.multiPlural);
    dynamicHTML = dynamicHTML.replaceAll('{{ link_domain }}', templateDataStructure.link_domain);
    dynamicHTML = dynamicHTML.replaceAll('{{prefix}}', templateDataStructure.prefix);
    dynamicHTML = dynamicHTML.replaceAll('{{current.plural}}', templateDataStructure.current.plural);
    dynamicHTML = dynamicHTML.replaceAll('{{current.prefix}}', templateDataStructure.prefix);
    dynamicHTML = dynamicHTML.replaceAll('{{current.multiPlural}}', templateDataStructure.current.multiPlural);

    //let compiled_html = template(templateDataStructure);
    // Replace the dynamic part of the modal with the compiled HTML.
    $dynamic.html(dynamicHTML);

    document.querySelector('#modalTriggeredManually').style.display = 'block';
    document.querySelector('#modalTriggeredAuto').style.display = 'none';

    $confirmModal.fadeIn(200);
  }

  function showGeoNotification(store) {
    debugger;
    var notification_html = $notificationTextSource
      .replaceAll('{{multiPlural}}', store.multiPlural || '')
      .replaceAll('{{link_domain}}', store.protocol + '//' + store.hosts[0] || 0);
    $notificationText.html(notification_html);
    // $notification.css("top", $(".announcement-bar-section").outerHeight() + $(".section-header").outerHeight());
    $notification.addClass('active');
  }

  $('[href="#store-selector"]').on('click', function (event) {
    event.preventDefault();

    $confirmModal.fadeOut(200);
    $selectModal.fadeIn(200);

    return false;
  });

  $('[data-store-selector]').on('click', function (event) {
    event.preventDefault();
    $selectModal.fadeOut(200);

    let code = $(this).data('store-selector');
    let store = stores[code];

    if (store) {
      showGEOModal(store);
    }

    return false;
  });

  $(document).on('click', '.geo-modal .close-modal', function (event) {
    event.preventDefault();

    var modal = $(this).closest('.geo-modal').fadeOut(200);

    if (modal.attr('id') === 'confirm-locale-modal') {
      if ($(this).hasClass('dont-ask-again')) {
        window.localStorage.geo_dont_ask = true;
      } else {
        window.sessionStorage.geo_redirect_dismissed = true;
      }

      var store = stores[window.localStorage.country];
      if (!store) {
        store = INT;
      }

      if (currentStore != store) {
        setTimeout(function () {
          showGeoNotification(store);
        }, 2000);
      }
    }

    return false;
  });

  $('.close-notification').on('click', function () {
    $notification.removeClass('active');
  });
});
